import type { PblCase } from '@/types/pbl';

export const fakePblInProgressCase: PblCase = {
  id: 42,
  case_id: 'LL-2026-000123',
  status: 'in_progress',
  oc_office_name: 'The Office of Thomas So Shiu-tsung, JP, Legislative Council Member',
  assisting_staff_name: 'Mr. Wong Ka Fai',
  office_contact: '+852 30624770',
  citizen_full_name_en: 'CHAN TAI MAN',
  identity_partial: 'A1234',
  phone: '+852 61234567',
  email: 'citizen@example.com',
  residential_address: 'Tai Po',
  enquiry_category: 'employment_disputes',
  factual_background: 'A detailed factual background for the enquiry.',
  specific_queries: 'I need legal advice.',
  primary_legal_service_needs: ['oral_legal_advice', 'document_review'],
  preferred_consultation_method: ['video_call'],
  created_at: '2026-04-28T08:00:00.000000Z',
  created_at_display: '2026/04/28 04:00 PM',
};

export const fakePblPendingEvaluationCase: PblCase = {
  ...fakePblInProgressCase,
  id: 125,
  case_id: 'DMP-2026-00125',
  status: 'pending_evaluation',
};
